let updated = false;

const setUpdateStatus = (status) => {
    updated = status
}

const getUpdateStatus = () => {
    return updated
}

export {
    setUpdateStatus,
    getUpdateStatus
}